import { Command as CommandPrimitive } from 'cmdk';
import React from 'react';

import { cn } from '@/services/utils';

const CommandGroup = React.forwardRef<
    React.ElementRef<typeof CommandPrimitive.Group>,
    React.ComponentPropsWithoutRef<typeof CommandPrimitive.Group>
>(({ className, ...props }, ref) => (
    <CommandPrimitive.Group
        ref={ref}
        className={cn(
            `tw-overflow-hidden
             tw-p-1
             tw-text-foreground
             [&_[cmdk-group-heading]]:tw-px-2
             [&_[cmdk-group-heading]]:tw-py-1.5
             [&_[cmdk-group-heading]]:tw-text-xs
             [&_[cmdk-group-heading]]:tw-font-medium
             [&_[cmdk-group-heading]]:tw-text-muted-foreground`,
            className
        )}
        {...props}
    />
));

CommandGroup.displayName = CommandPrimitive.Group.displayName;

export { CommandGroup };
